export default "__VITE_ASSET__31b14853__"